import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-generate-link',
  templateUrl: './generate-link.component.html',
  styleUrl: './generate-link.component.css'
})
export class GenerateLinkComponent implements OnInit {

  currentUser: any;
  myLink: any;

  constructor(private msg: NzMessageService) {}

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);
    this.myLink = `${environment.baseUrl}new/${this.currentUser.id}`;
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.myLink).then(() => {
      this.msg.success('Copied to clipboard')  
    });
  }

}
